// @ts-nocheck

import React, { useState, useEffect, useRef } from 'react'
import { Transactions as getTransactions, PoolTransactions } from '../../api/swap'
import styled from 'styled-components'
import subAddress from '../../utils/subAddress'
import multiply from '../../utils/multiply'
import formatLongNumber from '../../utils/formatLongNumber'
import moment from 'moment'
import { isMobile } from 'react-device-detect'
import { useHistory } from 'react-router-dom'
import thousandsSeparator from '../../utils/thousandsSeparator'
let BROWSER = process.env.REACT_APP_BROWSER

const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  margin-bottom: 10px;

  background: #fff;
  margin-bottom: 16px;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.68);
  }
  .item-left {
    display: flex;
    flex-direction: column;
    .price {
      font-weight: 500;
      font-size: 16px;
      color: #181818;
      span {
        font-size: 16px;
        margin-left: 10px;
        opacity: 0.6;
      }
    }
    .data {
      display: flex;
      align-items: center;
      gap: 18px;
      margin-top: 16px;

      div {
        font-weight: 600;
        font-size: 16px;
        color: rgba(0, 0, 0, 1);
        span {
          font-weight: 500;
          color: #707070;
        }
      }
      .pole {
      }
    }
    .volume {
      margin-top: 10px;
      font-weight: 400;
      font-size: 11px;
      color: #181818;
      span {
        font-weight: 600;
        font-size: 11px;
        color: #181818;
      }
    }
  }
  .item-center {
  }
  .item-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .address {
      font-weight: 500;
      font-size: 16px;
      color: #181818;
      text-align: end;
      &:hover {
        opacity: 0.6;
      }
    }
    .token {
      font-weight: 700;
      display: flex;
      align-items: center;

      font-size: 16px;
      color: rgba(24, 24, 24, 0.6);
      span {
        font-size: 20px;
        font-weight: 900;
        font-size: 20px;
        color: #e65262;
        margin-left: 10px;
        font-weight: 400;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 12px 14px;
    margin-bottom: 6px;
    .item-left {
      .price {
        font-weight: 700;
        font-size: 16px;
        span {
          font-size: 11px;
          margin-left: 6px;
        }
      }
      .data {
        margin-top: 10px;
        gap: 10px;

        div {
          font-size: 11px;
        }
      }
    }
    .item-right {
      .address {
        font-weight: 400;
        font-size: 11px;
      }
      .token {
        font-weight: 700;
        font-size: 11px;
        span {
          margin-right: 3px;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
`

export default function Transactions({ address, type = 'token', symbol }) {
  const history = useHistory()

  const [list, setList] = useState([])
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (type === 'token') {
          const { data } = await getTransactions({ Token: address ? address : '' })
          setList(data)
        } else {
          let { data } = await PoolTransactions({ Pair: address })
          setList(data)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [address])

  function isMilliseconds(timestamp: any) {
    if (typeof timestamp !== 'string' && typeof timestamp !== 'number') {
      throw new TypeError('Parameter must be a string or a number')
    }
    return timestamp.toString().length === 13
  }

  const handleTimeAgo = (time1: any, time2 = moment(), flag: any) => {
    // Ensure time1 and time2 are in milliseconds
    time1 = isMilliseconds(time1) ? time1 : time1 * 1000
    time2 = isMilliseconds(time2.valueOf()) ? time2.valueOf() : time2.valueOf() * 1000

    // Calculate the duration between time1 and time2
    const duration = moment.duration(moment(time2).diff(moment(time1)))

    // Get total days
    const totalDays = duration.asDays() // Get the total difference in days

    // Define time units
    const timeUnits = [
      { unit: 'day', value: Math.floor(totalDays) }, // Use integer number of days
      { unit: 'hr', value: duration.hours() },
      { unit: 'min', value: duration.minutes() },
      { unit: 'sec', value: duration.seconds() }
    ]

    // Iterate through the units to get the most significant one
    for (const { unit, value } of timeUnits) {
      if (value > 0) {
        return `${value} ${unit}${value > 1 ? 's' : ''} ${flag ? '' : 'ago'}`
      }
    }

    return '1 sec' // Fallback for very short time intervals
  }

  function jump(token) {

    
    if (token.toLocaleLowerCase() === address.toLocaleLowerCase()) return
    history.replace('/explore/tokens/' + token)
  }

  function jumpBrowser(address) {
    window.open(BROWSER + '/tx/' + address)
  }

  function jumpAddressBrowser(address) {
    window.open(BROWSER + '/address/' + address)
  }

  function isLess(amount) {
    if (Number(amount) > 0 && Number(amount) < 0.001) {
      return '<0.001'
    } else {
      return thousandsSeparator(formatLongNumber(amount, 3))
    }
  }

  return (
    <div className="list" style={{ marginTop: '16px' }}>
      {list.map((item, index) => {
        return (
          <Item
            key={index}
            onClick={() => {
              jumpBrowser(item.transactionHash)
            }}
          >
            <div className="item-left">
              <div className="price">
                ¥{thousandsSeparator(item.usd)}
                <span>CNY</span>
              </div>
              <div className="data">
                <div
                  onClick={e => {
                    e.stopPropagation()
                    jump(item.token0 === address ? item.token0 : item.token1)
                  }}
                >
                  <span>{/* {multiply(formatLongNumber(item?.amount0, 6))} {formatLongNumber(item.symbol0)} */}</span>
                  <span>
                    {item.token0 === address ? isLess(item.amount0) : isLess(item.amount1)}{' '}
                    {/* {symbol} */}
                    {item.token0 === address ? item.symbol0 : item.symbol1}
                  </span>
                </div>
                <div
                  onClick={e => {
                    e.stopPropagation()
                    jump(item.token0 === address ? item.token1 : item.token0)
                  }}
                >
                  <span>
                    {item.token0 === address ? isLess(item.amount1) : isLess(item.amount0)}{' '}
                    {item.token0 === address ? item.symbol1 : item.symbol0}
                  </span>
                </div>
              </div>
            </div>
            <div className="item-right">
              <div className="token">
                {handleTimeAgo(item.ts)}
                <span
                  style={{
                    fontWeight: '800',
                    color: item.token0 === address ? '#E65262' : '#12B298'
                  }}
                >
                  {item.token0 === address ? 'Sell' : 'Buy'}
                </span>
              </div>
              <div
                className="address"
                onClick={e => {
                  e.stopPropagation()
                  jumpAddressBrowser(item.from)
                }}
              >
                {subAddress(item?.from, 5)}
              </div>
            </div>
          </Item>
        )
      })}
    </div>
  )
}
